import React, { useRef, useState, useEffect }  from "react";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import { apiServices } from "../../services/apiServices";


const BloodPressure = (userData)=> {
  const chartRef = useRef(null);
  const [indicatorValues, setindicatorValues] = useState([]);
  const [monthNames, setmonthNames] = useState([]);
  useEffect(() => {
    let oRequest = {
      "param1":userData.userData.userData.userData.programOwners[0].program,
      "param2":userData.userData.userData.userData.orgUnit, 
      "param3":userData.userData.userData.userData.trackedEntityInstance
    }
  apiServices.postAPI('dashboardIndicator/getPatientData/get_custom_dashboard_bdpdetails', oRequest)
  .then((res) => {
    console.log("data>>", res.data.data)
    setindicatorValues(res.data.data.map(item => item.indicatorvalue));
    setmonthNames(res.data.data.map(item => item.monthname.trim()));  
  })
  .catch((error) => {
    console.log("error",error)
  })
  }, []);
 
  const data = indicatorValues;

  // Find the index of the point with a value of 8
  const indexOfEight = data.indexOf(8);

  // Set the marker color for the point with a value of 8 to pink
  const seriesData = data.map((value, index) => ({
    y: value,
    marker: {
      fillColor: index === indexOfEight ? '#ff779e' : '#00acb1'
    }
  }));

  const options =  {
    title: {
      text: '',
      align: 'left',
      x: 10,
      y: 10
    },
    credits: {
        enabled: false,
   },
    xAxis: {
      categories: monthNames,
    },
    yAxis: { 
      title: {
        text: ''
      },
      labels: {
        enabled: false // Hide the labels on the y-axis
      },
      tickInterval: 3
    },
    chart: {
        type: 'area',
      zoomType: 'none',
      backgroundColor: 'transparent',
    height:'250',
      resetZoomButton: false // Disable the reset zoom button
    },
    exporting:{
        enabled:true,
    },
    legend:{
      enabled: false,
    },
    series: [{
      name: '',
      connectNulls: true,
      lineColor: '#cbd196',
      lineWidth: 5,
      data: seriesData,
    //   marker: {
    //     symbol: 'circle',
    //     radius: 15, // Increase the radius for big circles
    //     lineWidth: 3,
    //     lineColor: '#cbd196', // Set to null to remove the border around the circle
    //     states: {
    //       hover: {
    //         enabled: false
    //       }
    //     }
    //   },
      // Data labels to permanently display values inside the circles
    //   dataLabels: {
    //     enabled: true,
    //     format: '{y}', // Display the y-value inside the circle
    //     style: {
    //       color: 'white', // Black color for the text inside the circles
    //       textOutline: 'none', // Remove text outline for better visibility
    //       fontWeight: 'bold' // Make the text bold for better visibility
    //     },
    //     // Position the data labels within the markers
    //     align: 'center',
    //     verticalAlign: 'middle'
    //   }
    }]
  }
  useEffect(() => {
    if (!chartRef.current) return;


  }, []);

  return (
    <div>
     <HighchartsReact
        highcharts={Highcharts}
        options={options}
      />
    </div>
//   <div ref={chartRef} />

    );
}

export default BloodPressure;
// ReactDOM.render(<SimpleLineChart />, document.getElementById('container'));
